import { render, staticRenderFns } from "./ExpenseForm.vue?vue&type=template&id=61fb9f2d&scoped=true"
import script from "./ExpenseForm.vue?vue&type=script&lang=js"
export * from "./ExpenseForm.vue?vue&type=script&lang=js"
import style0 from "./ExpenseForm.vue?vue&type=style&index=0&id=61fb9f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb9f2d",
  null
  
)

export default component.exports